/* eslint-disable react/jsx-handler-names */
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import { useUserInfoContext } from '../../../../..';

import MobileMenu from '../../MobileMenu';
import MobileMenuList from '../../MobileMenu/MobileMenuList';
import MobileMenuItem from '../../MobileMenu/MobileMenuItem';
import MobileMenuLink from '../../MobileMenu/MobileMenuLink';
import Separator from '../../MobileMenu/Separator';
import Logo from '../../../../base/Logo';
import LanguageSwitcher from '../../LanguageSwitcher';
import HeaderLogin from '../HeaderLogin';
import Badge from '../../Badge';

import linkShape from '../shapes/link.shape';
import loginShape from '../shapes/login.shape';
import SupportCenter from '../../SupportCenter';

import './HeaderNavMobile.scss';

const HeaderNavMobile = ({
  login,
  onClose = () => {},
  onAppClick = () => {},
  showLogin,
  showMessagesSection = true,
  isContactUsEnabled = false,
  ...links
}) => {
  const {
    home = {},
    listYourProperty = {},
    tenantLandingPage,
    howItWorks = {},
    favorites = {},
    changeCity = false,
    help = {},
    logo = {}
  } = links;

  const {
    userInfo: { chat }
  } = useUserInfoContext();

  const handleChangeCity = e => {
    if (changeCity.onClick && typeof changeCity.onClick === 'function') {
      changeCity.onClick(e);
    }
  };

  return (
    <MobileMenu
      logo={
        <a href={getPagePath('landing')} {...logo}>
          <Logo size="small" />
        </a>
      }
      onMobileAppButtonClick={onAppClick}
      onClose={onClose}
      className="header-nav-mobile__menu"
    >
      <MobileMenuList>
        {!!home && (
          <MobileMenuItem>
            <MobileMenuLink
              className="ga-home"
              href={getPagePath('landing')}
              {...links.home}
            >
              {home.label || trans('landing-pages.home')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        {!!listYourProperty && (
          <MobileMenuItem>
            <MobileMenuLink
              className="publish-your-property-mobile"
              href={getPagePath('externals.landlord-landing')}
              {...listYourProperty}
            >
              {listYourProperty.label || trans('landingpage.button.landlord')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        {!!tenantLandingPage && (
          <MobileMenuItem>
            <MobileMenuLink
              className="tenant-landing-page-mobile"
              href={getPagePath('landing')}
              {...tenantLandingPage}
            >
              {tenantLandingPage.label || trans('landingpage.button.tenant')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        {!!howItWorks && (
          <MobileMenuItem>
            <MobileMenuLink
              className="faqs-mobile"
              target="_blank"
              href={getPagePath('how-it-works')}
              {...howItWorks}
            >
              {howItWorks.label || trans('how_it_works.title')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        {!!favorites && (
          <MobileMenuItem>
            <MobileMenuLink
              href={getPagePath('marketplace.favorites')}
              target="_blank"
              rel="nofollow"
              {...favorites}
            >
              {favorites.label || trans('favorites.title.favorites')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        {showMessagesSection && chat?.openedChannels > 0 && (
          <MobileMenuItem>
            <MobileMenuLink
              href={getPagePath('tenant-messages')}
              target="_blank"
              rel="nofollow"
            >
              {trans('menu.messages.title')}
              {!!chat?.unreadChannels && chat.unreadChannels > 0 && (
                <Badge
                  label={String(chat.unreadChannels)}
                  theme="primary"
                  size="small"
                  className="header-nav-mobile__badge"
                />
              )}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        {!!changeCity && (
          <MobileMenuItem>
            <MobileMenuLink
              className="change-city"
              href={getPagePath('landing')}
              {...changeCity}
              onClick={handleChangeCity}
            >
              {changeCity.label || trans('change_city.title')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        <Separator />
        {showLogin || !!login ? <HeaderLogin {...login} isMobile /> : null}
        <Separator />

        {help && (
          <div className="header-nav-mobile__support-center">
            <SupportCenter
              backgroundColor="white"
              photo="blueLong"
              fontSize="medium"
              target="support"
            />
          </div>
        )}

        {isContactUsEnabled && (
          <MobileMenuItem>
            <MobileMenuLink href={getPagePath('contact-us')}>
              {trans('menu.contactus')}
            </MobileMenuLink>
          </MobileMenuItem>
        )}

        <MobileMenuItem>
          <MobileMenuLink>
            <LanguageSwitcher
              theme="dark"
              id="header-language-switcher-mobile"
            />
          </MobileMenuLink>
        </MobileMenuItem>
      </MobileMenuList>
    </MobileMenu>
  );
};

HeaderNavMobile.propTypes = {
  logo: PropTypes.shape(linkShape),
  home: PropTypes.shape(linkShape),
  landlordPanel: PropTypes.shape(linkShape),
  listYourProperty: PropTypes.shape(linkShape),
  howItWorks: PropTypes.shape(linkShape),
  favorites: PropTypes.shape(linkShape),
  help: PropTypes.shape(linkShape),
  changeCity: PropTypes.shape(linkShape),
  login: PropTypes.shape(loginShape).isRequired,
  onClose: PropTypes.func,
  onAppClick: PropTypes.func,
  isContactUsEnabled: PropTypes.bool,
  showLogin: PropTypes.bool.isRequired,
  showMessagesSection: PropTypes.bool
};

export default HeaderNavMobile;
